var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemberDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 2.5C8.43221 2.5 2.5 8.43221 2.5 15.75C2.5 23.0677 8.43221 28.9999 15.75 28.9999C23.0677 28.9999 28.9999 23.0677 28.9999 15.75C28.9999 8.43221 23.0677 2.5 15.75 2.5ZM1 15.75C1 7.60378 7.60378 1 15.75 1C23.8961 1 30.4999 7.60378 30.4999 15.75C30.4999 23.8961 23.8961 30.4999 15.75 30.4999C7.60378 30.4999 1 23.8961 1 15.75ZM11.5 10.25C10.81 10.25 10.25 10.8095 10.25 11.5C10.25 12.1906 10.81 12.75 11.5 12.75C12.19 12.75 12.75 12.1906 12.75 11.5C12.75 10.8095 12.19 10.25 11.5 10.25ZM8.75 11.5C8.75 9.98059 9.98203 8.75005 11.5 8.75005C13.018 8.75005 14.25 9.98059 14.25 11.5C14.25 13.0195 13.018 14.25 11.5 14.25C9.98203 14.25 8.75 13.0195 8.75 11.5ZM20 18.75C19.3099 18.75 18.75 19.3095 18.75 20C18.75 20.6906 19.3099 21.25 20 21.25C20.69 21.25 21.25 20.6906 21.25 20C21.25 19.3095 20.69 18.75 20 18.75ZM17.25 20C17.25 18.4806 18.482 17.25 20 17.25C21.5179 17.25 22.75 18.4806 22.75 20C22.75 21.5195 21.5179 22.75 20 22.75C18.482 22.75 17.25 21.5195 17.25 20ZM9.03033 23.5303L23.5303 9.03037L22.4696 7.96971L7.96967 22.4697L9.03033 23.5303Z",
    fill: "#6F757C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberDiscount);
export default __webpack_public_path__ + "static/media/member-discount.d9ba9947a4c8a35af809bfe00f440267.svg";
export { ForwardRef as ReactComponent };